class ParamBuilder {
  constructor() {
    this.search = ''
  }

  buildParam() {
    let res = ''

    if (this.search) {
      res += `query=${this.search}`
    }
    if (this.search && this.role) {
      res += `&roles=${this.role}`
    }
    return res
  }
}

export default ParamBuilder
